<script lang="ts" context="module">
  import {writable} from 'svelte/store';

  export const pixabaySearchStore = writable('');
</script>

<script lang="ts">
  import pixabayStore from './pixabay.store';
  import {onMount} from 'svelte';
  let debounceFn = setTimeout(() => {}, 1000);
  let inputTextEl: HTMLInputElement;

  function onChange() {
    clearTimeout(debounceFn);
    debounceFn = setTimeout(() => {
      pixabaySearchStore.set(inputTextEl.value);
      pixabayStore.search(inputTextEl.value);
    }, 500);
    // pixabayStore.search();
  }

  onMount(() => {
    if ($pixabaySearchStore !== '') inputTextEl.value = $pixabaySearchStore;
  });
</script>

<div class="flex w-full items-center overflow-hidden rounded-lg border border-gray-300 bg-zinc-50 py-1 text-zinc-500">
  <div class="block px-3 font-semibold">
    <i class="fa-regular fa-magnifying-glass"></i>
  </div>
  <input
    bind:this={inputTextEl}
    type="text"
    class="block w-full border-none bg-none p-1 text-zinc-700 outline-none"
    placeholder="Search for images"
    on:input={onChange}
  />
</div>
